export type TAsyncActionStatus =
'completed' |
'default' |
'failed' |
'loading';

export const AsyncActionStatus = {
  Completed: 'completed' as TAsyncActionStatus,
  Default: 'default' as TAsyncActionStatus,
  Failed: 'failed' as TAsyncActionStatus,
  Loading: 'loading' as TAsyncActionStatus,
};
